export class HistoryLockedError extends Error {
  constructor() {
    super('Conversation history is locked');
    this.name = 'HistoryLockedError';
  }
}

export class InvalidHistoryMarkerError extends Error {
  constructor() {
    super('Protected conversation has an invalid owner');
    this.name = 'InvalidHistoryMarkerError';
  }
}
